import type { McpArticle, McpArticleCollection } from '../../../types'

/**
 * Merge a collection's lazily-loaded pages with its base-tree items. An EMPTY loaded result must NEVER
 * clobber already-loaded base children: a NON-lazy source (Notion / Freshdesk / Zendesk / Intercom —
 * supports_lazy_articles=false) ships the FULL tree upfront (base items already populated), yet
 * expanding still fires the lazy fetch, which returns [] for those sources — replacing the real
 * children with [] made them "appear then suddenly vanish" on first expand. So prefer the loaded pages
 * only when NON-EMPTY; otherwise keep the base items. A genuinely lazy source (Confluence) has empty
 * base items, so keeping them on an empty result is a no-op there; a fetch error writes nothing to
 * loadedArticles (key absent → undefined → base items kept + retry on re-expand).
 */
export function mergeCollectionItems(
  baseItems: McpArticleCollection['items'],
  loaded: McpArticle[] | undefined,
): McpArticleCollection['items'] {
  return loaded?.length ? loaded : baseItems
}
